import { z } from 'zod';
import { SchemaTimestamp } from '@axiom/types';

export const CandidateReputationSchema = z.object({
  businessJudgementScore: z.number().nonnegative().nullable(),
  candidateId: z.string().uuid().nullish(),
  communicationScore: z.number().nonnegative().nullable(),
  createdAt: SchemaTimestamp.nullable(),
  displayableSurveyScoreData: z.boolean().default(false),
  hasEnoughRespondents: z.boolean().default(false),
  id: z.string().uuid().nullish(),
  legalExpertiseScore: z.number().nonnegative().nullable(),
  numberOfAxiomEngagements: z.number().int().nonnegative().default(0),
  numberOfEngagements: z.number().int().nonnegative().default(0),
  numberOfRespondents: z.number().int().nonnegative().default(0),
  numberOfReviews: z.number().int().nonnegative().default(0),
  numberOfTestimonials: z.number().int().nonnegative().default(0),
  percentageOfReEngagements: z.number().nonnegative().nullable(),
  reputationSummary: z.string().nullable(),
  responsivenessScore: z.number().nonnegative().nullable(),
  updatedAt: SchemaTimestamp.nullable(),
  yearsAtAxiom: z.number().nonnegative().default(0),
});

export type CandidateReputation = z.infer<typeof CandidateReputationSchema>;
